import SignupService from './signupService';
import CoordinatorService from './coordinatorService';
import OfficerService from './officerService';
import InvoiceService from './invoiceService';
import ApplicationService from './applicationService';
import AgencyService from './agencyService';
import ClientService from './clientService';
import ContactService from './contactService';
import JobService from './jobService';
import LocationService from './locationService';
import PostService from './postService';
import ProjectService from './projectService';
import UserService from './userService';
import PaymentService from './paymentService';
import InvoiceEstimatesService from './invoiceEstimatesService';
import OverviewService from './overviewService';
import NoteService from './noteService';
import OrganizationService from './organizationService';
import PlaidService from './plaidService';
import NonRKPayInvoiceService from './nonRKPayInvoiceService';

export default ({
	apiUrl,
	options,
	googleKey,
	geocoderURL,
}) => {
	SignupService.setup(apiUrl, options);
	CoordinatorService.setup(apiUrl, options);
	OfficerService.setup(apiUrl, options);
	InvoiceService.setup(apiUrl, options);
	AgencyService.setup(apiUrl, options);
	ContactService.setup(apiUrl, options);
	ProjectService.setup(apiUrl, options);
	UserService.setup(apiUrl, options);
	LocationService.setup(apiUrl, { geocoderURL, googleKey, ...options });
	ApplicationService.setup(apiUrl, options); // review cache system
	ClientService.setup(apiUrl, options);
	JobService.setup(apiUrl, options);
	PostService.setup(apiUrl, options);
	PaymentService.setup(apiUrl, options);
	InvoiceEstimatesService.setup(apiUrl, options);
	OverviewService.setup(apiUrl, options);
	NoteService.setup(apiUrl, options);
	OrganizationService.setup(apiUrl, options);
	PlaidService.setup(apiUrl, options);
	NonRKPayInvoiceService.setup(apiUrl, options);
};
